
        <ng-container kendoDropDownListLocalizedMessages
            i18n-noDataText="kendo.dropdownlist.noDataText|The text displayed in the popup when there are no items"
            noDataText="NO DATA FOUND"
        >
        </ng-container>
        <span #wrapper unselectable="on"
          role="listbox"
          [id]="focusableId"
          [ngClass]="{
            'k-dropdown-wrap': true,
            'k-state-default': !this.disabled,
            'k-state-disabled': this.disabled,
            'k-state-focused': this.isFocused
          }"
          [attr.dir]="direction"
          [attr.readonly]="readonly"
          [attr.tabindex]="widgetTabIndex"
          [attr.aria-disabled]="disabled"
          [attr.aria-readonly]="readonly"
          [attr.aria-haspopup]="ariaHasPopup"
          [attr.aria-expanded]="ariaExpanded"
          [attr.aria-owns]="ariaOwns"
          [attr.aria-activedescendant]="ariaActivedescendant"
          [attr.aria-label]="noDataLabel"
          (focus)="focusComponent()"
          (blur)="blurComponent()"
          (keydown)="keydown($event)"
          (keypress)="keypress($event)"
          (click)="click()"
        >
            <span [ngClass]="{ 'k-input': true }" unselectable="on">
               <ng-template *ngIf="valueTemplate"
                   [templateContext]="{
                       templateRef: valueTemplate.templateRef,
                       $implicit: dataItem
                   }">
               </ng-template>
               <ng-template [ngIf]="!valueTemplate">{{ getText() }}</ng-template>
           </span>
           <span [ngClass]="{ 'k-select': true}" unselectable="on">
               <span [ngClass]="buttonClasses"></span>
           </span>
           <ng-template #popupTemplate>
               <!--filterable-->

               <ng-template [ngIf]="filterable">
                   <span [ngClass]="{ 'k-list-filter': true }" (click)="$event.stopImmediatePropagation()">
                       <input
                           tabindex="-1"
                           [filterInput]="isFocused && !touchEnabled"
                           [dir]="direction"
                           [(ngModel)]="filterText"
                           class="k-textbox"
                           (keydown)="keydown($event)"
                           (input)="handleFilter($event)"
                           (focus)="onFilterFocus()"
                           (blur)="blurFilterInput()" />
                       <span [ngClass]="{ 'k-icon': true, 'k-i-search': true }" unselectable="on"></span>
                   </span>
               </ng-template>
               <!--default item-->
               <ng-template [ngIf]="defaultItem && !itemTemplate">
                   <div [ngClass]="setDefaultItemClasses()" kendoDropDownsSelectable [index]="-1">
                       {{ getDefaultItemText() }}
                   </div>
               </ng-template>
               <ng-template [ngIf]="defaultItem && itemTemplate">
                   <div [ngClass]="setDefaultItemClasses()" kendoDropDownsSelectable [index]="-1">
                       <ng-template
                           [templateContext]="{
                               templateRef: itemTemplate.templateRef,
                               $implicit: defaultItem
                           }">
                       </ng-template>
                   </div>
               </ng-template>
               <!--header template-->
               <ng-template *ngIf="headerTemplate"
                   [templateContext]="{
                       templateRef: headerTemplate.templateRef
                   }">
               </ng-template>
               <!--list-->
               <kendo-list
                   #optionsList
                   [id]="listBoxId"
                   [optionPrefix]="optionPrefix"
                   [data]="data"
                   [textField]="textField"
                   [valueField]="valueField"
                   [template]="itemTemplate"
                   [groupTemplate]="groupTemplate"
                   [fixedGroupTemplate]="fixedGroupTemplate"
                   [height]="listHeight"
                   [show]="isOpen"
                   >
               </kendo-list>
               <!--no-data template-->
               <div class="k-nodata" *ngIf="data.length === 0">
                   <ng-template [ngIf]="noDataTemplate"
                       [templateContext]="{
                           templateRef: noDataTemplate ? noDataTemplate.templateRef : undefined
                       }">
                   </ng-template>
                   <ng-template [ngIf]="!noDataTemplate">
                       <div>{{ noDataText }}</div>
                   </ng-template>
               </div>
               <!--footer template-->
               <ng-template *ngIf="footerTemplate"
                   [templateContext]="{
                       templateRef: footerTemplate.templateRef
                   }">
               </ng-template>
            </ng-template>
        </span>
        <ng-template [ngIf]="isOpen">
            <kendo-resize-sensor (resize)="onResize()"></kendo-resize-sensor>
        </ng-template>
        <ng-container #container></ng-container>
  